<span *ngIf="priceRange?.lowest?.bookingFee?.amountMicros > 0">
    <!-- From -->
    <app-booking-price [fees]="priceRange.lowest"></app-booking-price>
    <!-- / day -->
</span>
